// These are the only colors that we should ever use in the app.
// Even though tailwind comes with colors included we shouldn't use them, we
// should only ever use colors from this palette. If any color is missing, talk to
// the design team to get it added.

// Base color constants
const ST_BLACK = '#151515';
const ST_WHITE = '#FFFFFF';
const ST_CREME = '#FAF6F2';

const ST_GRAY_500 = '#979797';
const ST_YELLOW_500 = '#FFDB00';
const ST_GREEN_500 = '#008744';
const ST_BLUE_500 = '#1573DE';
const ST_RED_500 = '#DC2626';
const ST_PINK_500 = '#E00F8F';

const colors = {
  'st-black': ST_BLACK,
  'st-white': ST_WHITE,
  'st-creme': ST_CREME,

  'st-gray': {
    DEFAULT: ST_GRAY_500,
    100: '#FAFAFA',
    200: '#EEEEEE',
    300: '#DDDDDD',
    400: '#CCCCCC',
    500: ST_GRAY_500,
    600: '#757575',
    700: '#505050',
    800: '#2D2D2D',
    900: '#040404',
  },

  'st-yellow': {
    DEFAULT: ST_YELLOW_500,
    100: '#FFF8CC',
    200: '#FFF199',
    300: '#FFE966',
    400: '#FFE233',
    500: ST_YELLOW_500,
    600: '#CFB303',
    700: '#A18A08',
    800: '#72640C',
    900: '#423B0F',
  },

  'st-green': {
    DEFAULT: ST_GREEN_500,
    100: '#F2F8F5',
    200: '#E6F2EC',
    300: '#AADEC4',
    400: '#55BE89',
    500: ST_GREEN_500,
    600: '#007D3E',
    700: '#006633',
    800: '#005C2E',
    900: '#00341A',
  },

  'st-blue': {
    DEFAULT: ST_BLUE_500,
    100: '#D0E3F8',
    200: '#A1C7F1',
    300: '#72ABEB',
    400: '#438FE4',
    500: ST_BLUE_500,
    600: '#105CB1',
    700: '#0C4585',
    800: '#082D58',
    900: '#04162C',
  },

  'st-red': {
    DEFAULT: ST_RED_500,
    100: '#FCF2F4',
    200: '#F9E6E8',
    300: '#F58E8E',
    400: '#EF4444',
    500: ST_RED_500,
    600: '#B91C1C',
    700: '#991B1B',
    800: '#7F1D1D',
    900: '#570F0F',
  },

  'st-pink': {
    DEFAULT: ST_PINK_500,
    100: '#F8CFE8',
    200: '#F29FD2',
    300: '#EC6FBB',
    400: '#E63FA5',
    500: ST_PINK_500,
    600: '#B30C72',
    700: '#860955',
    800: '#590539',
    900: '#2C021C',
  },
};
export default colors;
